import i18n from 'i18next';
import { NavigationStore } from '@24i/nxg-core-utils/src/globalSingletons';
import { Payload, TitleForSpecialScreens } from './types';

// we need to move this enum from smartott package to here (this package)
export enum SPECIAL_TRANSLATED_SCREENS {
    PLAYBACK = 'appstage-screen-player',
    DETAILS = 'appstage-screen-details',
    SEE_ALL = 'appstage-screen-see-all',
    DYNAMIC_CONTENT = 'DynamicContent',
}

export enum SPECIAL_TRANSLATED_TV_SCREENS {
    PLAYBACK = 'Playback',
    DETAILS = 'Details',
    SEE_ALL = 'SeeAll',
    DYNAMIC_CONTENT = 'DynamicContent',
}

export const handleTitleForSpecialScreens = ({
    screen,
    params,
    screenTitle,
    hasPreviousScreen = false,
}: TitleForSpecialScreens): string => {
    const genericTitle =
        params.payload?.params?.title ||
        params.payload?.params?.asset?.title ||
        params.payload?.asset?.title;

    const assetOnlyTitle = params.payload?.params?.asset?.title || params.payload?.asset?.title;

    switch (screen) {
        case SPECIAL_TRANSLATED_SCREENS.SEE_ALL:
        case SPECIAL_TRANSLATED_TV_SCREENS.SEE_ALL:
            return i18n.t('analytics.documentTitle.seeAll', { rowTitle: genericTitle });

        case SPECIAL_TRANSLATED_SCREENS.DETAILS:
        case SPECIAL_TRANSLATED_TV_SCREENS.DETAILS:
            return hasPreviousScreen
                ? i18n.t('analytics.documentTitle.detail', { assetTitle: assetOnlyTitle })
                : SPECIAL_TRANSLATED_TV_SCREENS.DETAILS;

        case SPECIAL_TRANSLATED_SCREENS.PLAYBACK:
        case SPECIAL_TRANSLATED_TV_SCREENS.PLAYBACK:
            return hasPreviousScreen
                ? i18n.t('analytics.documentTitle.player', { assetTitle: genericTitle })
                : SPECIAL_TRANSLATED_TV_SCREENS.PLAYBACK;

        case SPECIAL_TRANSLATED_SCREENS.DYNAMIC_CONTENT:
        case SPECIAL_TRANSLATED_TV_SCREENS.DYNAMIC_CONTENT:
            return params?.payload?.params?.screenName || params.payload.pageId;
        default:
            return screenTitle || '';
    }
};

export const getFormattedOriginalSourcePage = (
    payload: Payload,
    usePreviousState = false
): string => {
    const currentState = usePreviousState
        ? NavigationStore.getPreviousState()
        : NavigationStore.getCurrentState();
    return handleTitleForSpecialScreens({
        screen: currentState?.routeId || payload?.payload?.pageId || payload?.payload?.screen || '',
        params: payload,
        screenTitle: currentState?.title || payload?.payload?.title || '',
        hasPreviousScreen: !!currentState?.routeId,
    });
};

export const isPlayerScreenActive = (): boolean => {
    const { routeId } = NavigationStore.getCurrentState() || {};
    return (
        routeId === SPECIAL_TRANSLATED_SCREENS.PLAYBACK ||
        routeId === SPECIAL_TRANSLATED_TV_SCREENS.PLAYBACK
    );
};
